module.exports = __webpack_public_path__ + "static/media/pod-unassigned.895f376b.svg";